import OrderStatus from "@/enum/OrderStatus";

const OrderStatusNameMap = {
    [OrderStatus.PENDING_SHIPMENT]: "待发货",

    [OrderStatus.PENDING_PAYMENT]: "未付款",

    [OrderStatus.SHIPPED]: "已发货",

    [OrderStatus.SUCCESS]: "交易成功",

    [OrderStatus.CANCELED]: "已取消",
};

export default OrderStatusNameMap;
